import { useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function Unsubscribe() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await api.post("/unsubscribe", { email }).catch((err) => { throw new Error(formatApiErrorDetail(err.response?.data?.detail) || "Unsubscribe failed"); });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <Seo
        title="Unsubscribe | Coastal Energy — Commercial Solar ROI"
        description="Stop all marketing emails from Coastal Energy and Commercial Solar ROI. Enter your email to unsubscribe immediately."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">EMAIL PREFERENCES</span>
          <h1 data-testid="unsubscribe-heading">Unsubscribe from marketing emails</h1>
          <p className="lead">
            Enter your email address and we stop all marketing emails to it right away. Requests about saved
            projects (quotes, audits, service visits) are not marketing — the project team may still contact you
            about work you asked for.
          </p>
        </div>
      </section>
      <section style={{ paddingBottom: 60 }}>
        <div className="wrap" style={{ maxWidth: 560 }}>
          {done ? (
            <div className="panel" data-testid="unsubscribe-success" role="status">
              <h2 style={{ margin: "12px 0" }}>You're unsubscribed.</h2>
              <p className="muted" style={{ fontSize: 13 }}>
                No more marketing emails will be sent to <b>{email}</b>. Changed your mind? Call
                310-881-5155 or <Link to="/contact">send a message</Link>.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="unsubscribe-form">
              <label className="field">
                Email address
                <input required type="email" maxLength={254} autoComplete="email" data-testid="unsubscribe-email"
                  value={email} onChange={(e) => setEmail(e.target.value)} />
              </label>
              <button className="btn" type="submit" disabled={busy} data-testid="unsubscribe-submit" style={{ marginTop: 16 }}>
                {busy ? "Saving…" : "Stop marketing emails"}
              </button>
              {error && (
                <p className="status" role="alert" style={{ color: "#a33a17" }} data-testid="unsubscribe-error">{error}</p>
              )}
              <p className="micro" style={{ marginTop: 14 }}>
                To stop TEXTS, reply STOP to any text we sent. To stop CALLS, tell us on the line or email
                info@sandsiftenvironmental.com. See the <Link to="/privacy">privacy page</Link> for details.
              </p>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
